// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"399":"98471e72","453":"8b6d8cda","620":"08cb41bd"}[chunkId] + ".chunk.js";
};